import { render, staticRenderFns } from "./examBg.vue?vue&type=template&id=32c31826&scoped=true"
import script from "./examBg.vue?vue&type=script&lang=ts"
export * from "./examBg.vue?vue&type=script&lang=ts"
import style0 from "./examBg.vue?vue&type=style&index=0&id=32c31826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c31826",
  null
  
)

export default component.exports